// First Time mode: which tips this device has already seen, so they do not
// repeat. Saved in localStorage (blocked storage just means tips may show
// again). Settings > Game > "Show tips again" clears the list.
import { useSyncExternalStore } from "react";
import { browserStorage } from "./settings";

const TIPS_KEY = "wp.tipsSeen.v1";

function read(): ReadonlySet<string> {
  try {
    const text = browserStorage()?.getItem(TIPS_KEY);
    const list: unknown = text ? JSON.parse(text) : [];
    return new Set(Array.isArray(list) ? list.filter((x): x is string => typeof x === "string") : []);
  } catch {
    return new Set();
  }
}

let seen: ReadonlySet<string> = read();
const listeners = new Set<() => void>();

function write(next: ReadonlySet<string>): void {
  seen = next;
  try {
    browserStorage()?.setItem(TIPS_KEY, JSON.stringify([...next]));
  } catch {
    // Quota / private mode: remembered for this visit only.
  }
  for (const l of listeners) l();
}

export function markTipSeen(id: string): void {
  if (!seen.has(id)) write(new Set([...seen, id]));
}

/** Forget every seen tip: they all show again (First Time mode must be on). */
export function resetTips(): void {
  write(new Set());
}

function subscribe(l: () => void): () => void {
  listeners.add(l);
  return () => listeners.delete(l);
}

/** The ids of the tips already seen on this device (re-renders when it changes). */
export function useTipsSeen(): ReadonlySet<string> {
  return useSyncExternalStore(subscribe, () => seen);
}
